// /src/routes/navbar/navbar.lang.es.js
const navbarES = {
	brand: "SinFila",

	admin: {
		calendar: "Calendario",
		profile: "Perfil",
		billing: "Facturación",
		team: "Equipo",
		account: "Cuenta",

		// Scheduling
		staffSchedule: "Horario del personal",
		openingHours: "Horario de apertura",

		// Onboarding / setup
		showSteps: "Ver pasos",
		hideSteps: "Ocultar pasos",
		stepsCompleted: "{done} / {total} pasos completados ({percent}%)",
		launchShop: "Publicar negocio",
		launchStaff: "Activar personal",
		launchingStaff: "Activando personal",
		redirecting: "Redirigiendo...",
		billingError: "No se pudo iniciar la facturación",
	},

	search: {
		placeholder: "Buscar servicios o negocios",
		where: "¿Dónde?",
		button: "Buscar",
	},

	auth: {
		signin: "Entrar",
		logout: "Cerrar sesión",
		listShop: "Publica tu negocio",
		profile: "Perfil",
		shop: "Negocio",
	},

	language: {
		english: "English",
		spanish: "Español",
	},

	categories: {
		hairsalon: "Salón de belleza",
		barbershop: "Barbería",
		nailsalon: "Uñas",
		skincare: "Cuidado de la piel",
		browslashes: "Cejas y pestañas",
		massage: "Masajes",
		makeup: "Maquillaje",
		wellnessspa: "Spa y bienestar",
	},

	mobile: {
		home: "Inicio",
		bookings: "Reservas",
		list: "Publicar",
		signin: "Entrar",
		logout: "Salir",
		business: "Negocios",
		explore: "Explorar", 
	},
};

export default navbarES;
